import React from 'react';
import c from 'classnames';

type Props = {
  className?: string;
};

const CardContent: React.FC<Props> = (props) => {
  const { children, className } = props;

  const classes = c('Card__content', className);

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default CardContent;
